import { render } from "./AGallery.vue?vue&type=template&id=c87d6b14&scoped=true"
import script from "./AGallery.vue?vue&type=script&lang=js"
export * from "./AGallery.vue?vue&type=script&lang=js"

import "./AGallery.vue?vue&type=style&index=0&id=c87d6b14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c87d6b14"]])

export default __exports__